var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"chronology"},[_c('b-col',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"xl":"10"}},[(_vm.edges)?_c('VideoPlayer',{attrs:{"src":_vm.fullpath}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }